import React from 'react';

const GOLD = '#C8A84B';

const S = {
  nav: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 24px', borderBottom:'1px solid rgba(200,168,75,0.2)', background:'rgba(251,247,238,0.97)', backdropFilter:'blur(12px)', position:'sticky', top:0, zIndex:100, fontFamily:"'DM Sans','Segoe UI',sans-serif" },
  logo: { display:'flex', flexDirection:'column', cursor:'pointer', gap:1 },
  logoTop: { display:'flex', alignItems:'center', gap:8 },
  mark: { width:30, height:30, borderRadius:7, background:'rgba(200,168,75,0.12)', border:'1px solid rgba(200,168,75,0.35)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:800, color:GOLD, fontFamily:"'Cinzel',serif" },
  word: { fontSize:17, fontWeight:800, letterSpacing:'0.12em', color:"#1A1408", fontFamily:"'Cinzel',serif" },
  logoSub: { fontSize:7, letterSpacing:'1px', color:'rgba(200,168,75,0.5)', fontFamily:"'Cinzel',serif", paddingLeft:38 },
  right: { display:'flex', alignItems:'center', gap:8 },
  chip: { display:'flex', alignItems:'center', gap:4, background:'rgba(200,168,75,0.06)', border:'1px solid rgba(200,168,75,0.18)', borderRadius:20, padding:'4px 10px', fontSize:12 },
  val: { fontWeight:700, color:GOLD },
  btn: (active) => ({ padding:'6px 14px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', border:'1px solid ' + (active ? 'rgba(200,168,75,0.5)' : 'rgba(200,168,75,0.15)'), background: active ? 'rgba(200,168,75,0.12)' : 'transparent', color: active ? GOLD : 'rgba(26,20,8,0.4)', transition:'all 0.2s', fontFamily:"'DM Sans','Segoe UI',sans-serif" }),
};

export default function Nav({ screen, onNav, xp, streak, level }) {
  return (
    <nav style={S.nav}>
      <div style={S.logo} onClick={() => onNav('home')}>
        <div style={S.logoTop}>
          <div style={S.mark}>A</div>
          <span style={S.word}>ARIA</span>
        </div>
        <div style={S.logoSub}>Artificial Intelligence Resource and Instruction Academy</div>
      </div>
      <div style={S.right}>
        <div style={S.chip}><span>🔥</span><span style={S.val}>{streak}d</span></div>
        <div style={S.chip}><span style={S.val}>{xp} XP</span></div>
        <button style={S.btn(screen==='progress')} onClick={() => onNav('progress')}>Progress</button>
        <button style={S.btn(screen==='coach')} onClick={() => onNav('coach')}>Talk to ARIA</button>
      </div>
    </nav>
  );
}
